module.exports = [
    {
        link: 'empty-cans-of-pringles-spring-onion-165-g-with-the-inscription-smff-ate-this',
        name: 'Пустая банка «Pringles «Spring Onion», 165 г. с надписью «smff ate this»',
        price: 700
    },
    {
        link: 'part-of-the-packaging-puzzle-eureka-no-2-says-smff-solved-this',
        name: 'Часть упаковки от головоломки «Эврика «№2» с надписью «smff solved this»',
        price: 777
    },
    {
        link: 'an-empty-bottle-of-lager-at-the-brewery-the-sun-is-not-offended-by-firefly-with-a-volume-of-045-l-with-the-inscription-smff-drank-this',
        name: 'Пустая бутылка из-под лагера «Волковская пивоварня «Солнце не обижается на светлячка» объемом 0.45 л с надписью «smff drank this»',
        price: 707
    },
    {
        link: 'map-of-the-walking-route-in-the-vladimir-region-labeled-smff-walked-here',
        name: 'Карта пешего маршрута по Владимирской области с надписью «smff walked here»',
        price: 770
    },
    {
        link: 'used-stick-heets-amber-selection-with-the-words-smff-smoked-this',
        name: 'Использованный стик «HEETS «Amber selection» с надписью «smff smoked this»',
        price: 770
    },
    {
        link: 'used-phone-case-iphone-55s-with-the-words-smff-used-this',
        name: 'Ношеный чехол для телефона «Apple iPhone 5/5S» с надписью «smff used this»',
        price: 777
    },
    {
        link: 'empty-packing-fromunder-pistachio-beerka-fried-salt-80-g-with-an-inscription-smff-ate-this',
        name: 'Пустая упаковка из-под фисташек «BEERka «жаренные соленые», 80 г. с надписью «smff ate this»',
        price: 700
    },
    {
        link: 'the-projection-lamp-disco-with-the-words-smff-sold-this',
        name: 'Светильник проекционный «Disco» с надписью «smff sold this»',
        price: 700
    }
];
